import React from "react";
import {
    Eye,
    CheckCircle,
    XCircle,
    Loader2,
    Trash2,
    Edit2,
} from "lucide-react";

const ToolTable = ({
    tools,
    categories,
    onViewTool,
    onApproveTool,
    onRejectTool,
    onDeleteTool,
    showDeleteButton,
    isLoading,
}) => {
    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
            </div>
        );
    }

    if (!tools.length) {
        return (
            <div className="text-center py-12">
                <h3 className="text-lg font-medium text-gray-900 mb-4">
                    No tools found
                </h3>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="w-full">
                <thead>
                    <tr className="text-left text-sm text-gray-500">
                        <th className="pb-4">Name</th>
                        <th className="pb-4">Company</th>
                        <th className="pb-4">Category</th>
                        <th className="pb-4">External URL</th>
                        <th className="pb-4">Internal URL</th>
                        <th className="pb-4">Submitted At</th>
                        <th className="pb-4">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {tools.map((tool) => {
                        return (
                            <tr key={tool.uuid} className="border-t">
                                <td className="py-4">{tool.name}</td>
                                <td className="py-4">{tool.company}</td>
                                <td className="py-4">{tool.category}</td>
                                <td className="py-4">
                                    <a
                                        href={tool.externalUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:text-blue-700 hover:underline"
                                    >
                                        {tool.externalUrl}
                                    </a>
                                </td>
                                <td className="py-4">
                                    <a
                                        href={`/tool/${tool.name}`}
                                        target="_blank"
                                        className="text-blue-600 hover:text-blue-700 hover:underline"
                                    >
                                        link
                                    </a>
                                </td>
                                <td className="py-4">
                                    {new Date(
                                        tool.createdAt
                                    ).toLocaleDateString()}
                                </td>
                                <td className="py-4">
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => onViewTool(tool)}
                                            className="text-blue-600 hover:text-blue-700"
                                            title="View Details"
                                        >
                                            <Eye className="h-4 w-4" />
                                        </button>
                                        {tool.status === "Under Review" && (
                                            <>
                                                <button
                                                    onClick={() =>
                                                        onApproveTool(tool.uuid)
                                                    }
                                                    className="text-green-600 hover:text-green-700"
                                                    title="Approve"
                                                >
                                                    <CheckCircle className="h-4 w-4" />
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        onRejectTool(tool.uuid)
                                                    }
                                                    className="text-red-600 hover:text-red-700"
                                                    title="Reject"
                                                >
                                                    <XCircle className="h-4 w-4" />
                                                </button>
                                            </>
                                        )}
                                        {/*tool.status === "Approved" && (
                                            <button
                                                onClick={() => onViewTool(tool)}
                                                className="text-blue-600 hover:text-blue-700"
                                                title="Edit Tool"
                                            >
                                                <Edit2 className="h-4 w-4" />
                                            </button>
                                        )*/}
                                        {showDeleteButton && onDeleteTool && (
                                            <button
                                                onClick={() =>
                                                    onDeleteTool(tool.uuid)
                                                }
                                                className="text-red-600 hover:text-red-700"
                                                title="Delete"
                                            >
                                                <Trash2 className="h-4 w-4" />
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ToolTable;
